module.exports = __webpack_public_path__ + "img/Map_footer_mobile.b87ad8d0.png";